import api from 'api'

export type ShiftWorkBreak = {
  breakNumber: number
  durationInMinutes: number
  startTime?: string | null
  endTime?: string | null
  status?: 'taking' | 'taken' | 'waived' | 'missed' | null
  presentationStatus:
    | 'scheduled'
    | 'available'
    | 'overdue'
    | 'taking'
    | 'resolved'
  reason?: string | null
  takeAfter?: string | null
  takeBefore?: string | null
  breakType: 'meal' | 'rest'
  requirementType: 'required' | 'optional'
  waivePolicy?: 'allowed' | 'allowed_if_previous_taken' | null
  payTreatment: 'paid' | 'unpaid'
  issue?: 'required_not_recorded' | 'in_progress' | 'required_not_taken' | null
}

type GetShiftWorkBreaksResponse = {
  breaks: ShiftWorkBreak[]
}

export const getShiftWorkBreaks = async (
  workId: number
): Promise<ShiftWorkBreak[]> => {
  const response = await api.get<GetShiftWorkBreaksResponse>(
    `/admin/work/${workId}/break`
  )

  return response.data.breaks
}
